import axios from "axios";
import { API_URL } from "../utils/apiUtils";
import { toast } from "react-toastify";

export const imageUploadService = async (formData) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.post(
      `${API_URL}/util/image-upload`,
      formData,
      {
        headers: {
          accessToken: token,
        },
      }
    );
    toast.success("Image uploaded successfully!");
    return response.data.url;
  } catch (error) {
    toast.error("Image upload error");
  }
};
